import styled from 'styled-components';

export const CallButtonStyles = styled.div`
  display: none;
  @media screen and (max-width: 512px) {
    position: fixed;
    z-index: 10;
    right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.color_green};
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
    bottom: calc(10px + var(--bottom-mobile-menu));
  }
`;
